// components/PublicRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.tsx';
import { Spinner } from 'reactstrap';

const PublicRoute = ({ children }) => {
    const { user, loading, isAuthenticated, userRole } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center min-vh-100">
                <div className="text-center">
                    <Spinner color="primary" />
                    <p className="mt-2"></p>
                </div>
            </div>
        );
    }

    // If authenticated, redirect based on role
    if (isAuthenticated && user) {
        const getRedirectPath = () => {
            if (['admin', 'administrator', 'superadmin'].includes(userRole || '')) {
                return '/admin/dashboard';
            } else {
                return '/panel/dashboard';
            }
        };

        const redirectPath = getRedirectPath();
        const from = location.state?.from?.pathname;

        return <Navigate to={from || redirectPath} replace />;
    }

    // If not authenticated, show the public page
    return children;
};

export default PublicRoute;